import RecruitmentKanban from "@/components/recruitment-kanban"

export default function PipelinePage() {
  return (
    <div className="container mx-auto py-6 space-y-6">
      <RecruitmentKanban />
    </div>
  )
} 